import{o as e}from"./chunk-CDW2662X.js";import{m as t}from"./chunk-HBP5N4FR.js";t();e();var w=()=>window!=null&&window.ReactNativeWebView?"reactNative":window.webkit?"ios":"web";export{w as a};
//# sourceMappingURL=chunk-J3Q7UDAZ.js.map
